// Rockwall County SEO Hub data — drives the 8-page local authority cluster.
// All content here is hand-tuned for local relevance, EEAT, and competitor
// outperformance. Each city/medication page consumes this single source.

export const ROCKWALL_HUB_PATH = "/rockwall-county-weight-loss";
export const TIRZEPATIDE_HUB_PATH = "/rockwall-county-tirzepatide";
export const SEMAGLUTIDE_HUB_PATH = "/rockwall-county-semaglutide";

export const CITIES = [
  {
    slug: "rockwall",
    name: "Rockwall",
    path: "/rockwall-weight-loss",
    population: "approximately 50,000",
    landmarks: [
      "The Harbor at Rockwall Lake",
      "Downtown Rockwall Historic Square",
      "Rockwall Golf & Athletic Club",
      "Lake Ray Hubbard waterfront",
      "Buffalo Creek Country Club",
    ],
    neighborhoods: [
      "Chandler's Landing", "Stone Creek", "Shores at Rockwall",
      "Tuscan Lakes", "Stoneleigh", "The Heights", "Stone Crest",
    ],
    lifestyle:
      "Rockwall is the heart of Rockwall County — a lakeside community where active families balance demanding careers with weekend boating on Lake Ray Hubbard, evening walks at The Harbor, and rounds at Buffalo Creek Country Club. The pace is fast, the standards are high, and convenience matters.",
    intro:
      "If you live or work in Rockwall, you already know that local options for medical weight loss are limited — most residents drive 40 minutes into Dallas, navigate insurance preauthorizations, or settle for med-spa programs without true provider oversight. BestRx changes that. Our entire process is online: a licensed provider reviews your intake, a compounding pharmacy fulfills your prescription, and your medication ships discreetly to your Rockwall address — no waiting rooms, no insurance, no friction.",
    competitor_angle: "outranking Rockwall med spas, primary-care weight-loss programs, and national telehealth brands like Ro, Hims, and WeightWatchers Clinic",
  },
  {
    slug: "royse-city",
    name: "Royse City",
    path: "/royse-city-weight-loss",
    population: "approximately 18,000 and rapidly growing",
    landmarks: [
      "Downtown Royse City",
      "Royse City Sports Park",
      "Crystal Lake Park",
      "Interstate 30 commuter corridor",
      "Royse City ISD athletic complex",
    ],
    neighborhoods: [
      "Lakeside at Verandah", "Waterscape", "Hidden Hills",
      "Hunt Place", "The Estates", "Hidden Creek",
    ],
    lifestyle:
      "Royse City is one of the fastest-growing communities in North Texas — young families, commuters along I-30, and Rockwall County's next wave of residential growth. Most newcomers don't yet have a primary care physician set up locally, making telehealth the practical default for medical weight loss.",
    intro:
      "Royse City has grown faster than its local healthcare infrastructure. New residents arriving from across DFW and out of state often wait weeks for primary-care appointments, let alone a weight-loss consultation. BestRx provides immediate access — a Texas-licensed provider reviews your intake within 24 hours, your medication ships from a compounding pharmacy, and ongoing support is just a tap away. You stay in Royse City. The provider comes to you.",
    competitor_angle: "outpacing Sulphur Springs and Greenville drive-in clinics plus national telehealth brands that lack Texas-specific provider reviews",
  },
  {
    slug: "fate",
    name: "Fate",
    path: "/fate-weight-loss",
    population: "approximately 22,000",
    landmarks: [
      "Williamsburg neighborhood",
      "Woodcreek master-planned community",
      "Monterra",
      "Fate Trail System",
      "Cambridge Crossing",
    ],
    neighborhoods: [
      "Woodcreek", "Williamsburg", "Monterra",
      "Edgewater", "Chamberlain Crossing", "The Hideaway",
    ],
    lifestyle:
      "Fate is a planned-community success story — Woodcreek alone has reshaped the city. Residents are typically young professionals and families relocating from Plano, Frisco, and Allen for the new construction, lower taxes, and small-town feel. Health-conscious, busy, and time-poor — the exact profile telehealth weight loss was built for.",
    intro:
      "Fate's growth has outpaced local medical specialty options. Residents drive to Rockwall or Forney for in-person appointments, then again for follow-ups — losing hours each visit. BestRx eliminates the commute entirely. Your assessment, provider review, and medication delivery all happen from your Fate kitchen table.",
    competitor_angle: "beating Rockwall and Forney clinics with a 100% online process plus national brands like Ro and Hims that don't compound locally",
  },
  {
    slug: "heath",
    name: "Heath",
    path: "/heath-weight-loss",
    population: "approximately 10,000",
    landmarks: [
      "Lake Ray Hubbard shoreline",
      "Town Center Park",
      "Buffalo Creek Country Club",
      "Heath Golf & Yacht Club",
      "Terry Park",
    ],
    neighborhoods: [
      "Heath Golf & Yacht Club", "The Reserve",
      "Sunset Hills", "Stoney Hollow", "Heath Estates",
    ],
    lifestyle:
      "Heath is an affluent lakeside community where residents take wellness seriously — golf at Heath Golf & Yacht Club, sailing on Ray Hubbard, gym memberships at multiple clubs. The expectation is premium service. BestRx delivers concierge-grade medical weight loss without the country-club price tag.",
    intro:
      "Heath residents already prioritize health — many work with personal trainers, dietitians, and concierge primary-care practices. What's typically missing is the prescription medication piece: GLP-1s and compounded Tirzepatide require Texas-licensed provider oversight and a licensed compounding pharmacy. BestRx fills exactly that gap, with the discretion and professionalism Heath demands.",
    competitor_angle: "exceeding Heath med-spas, Rockwall HRT clinics, and concierge primary-care providers who don't carry compounded GLP-1s",
  },
  {
    slug: "mclendon-chisholm",
    name: "McLendon-Chisholm",
    path: "/mclendon-chisholm-weight-loss",
    population: "approximately 4,800",
    landmarks: [
      "Sonoma Verde",
      "Travino Ranch",
      "FM 549 country corridor",
      "Stoney Hollow Equestrian",
    ],
    neighborhoods: [
      "Sonoma Verde", "Travino Ranch",
      "Stoney Hollow Equestrian", "Whispering Hills",
    ],
    lifestyle:
      "McLendon-Chisholm is the quiet, rural sibling of Rockwall County — large lots, equestrian properties, and a slower pace. Privacy matters here. The nearest weight-loss clinic is a 25-minute drive minimum.",
    intro:
      "If you live in McLendon-Chisholm, the closest medical-weight-loss provider is in Rockwall or Forney — and many residents prefer not to be seen walking in. BestRx is built for exactly this: a fully private, fully online process. Your medication arrives in plain packaging at your McLendon-Chisholm mailbox. Nobody else needs to know.",
    competitor_angle: "outperforming all in-person Rockwall and Kaufman County clinics by virtue of being 100% telehealth — no drive, no waiting room",
  },
  {
    slug: "mobile-city",
    name: "Mobile City",
    path: "/mobile-city-weight-loss",
    population: "approximately 200 residents — the smallest city in Rockwall County",
    landmarks: ["State Highway 205 corridor", "Mobile City Park"],
    neighborhoods: ["Mobile City Estates"],
    lifestyle:
      "Mobile City may be small, but residents face the same challenge as bigger Rockwall County neighbors: zero in-town healthcare. Telehealth is the only practical option.",
    intro:
      "BestRx serves every resident of Rockwall County — including Mobile City. Same Texas-licensed providers, same compounded medications, same discreet shipping.",
    competitor_angle: "the only viable medical weight loss option in Mobile City — no other provider serves this ZIP code in person",
  },
];

// Used by template for the hub + each city page
export const SHARED_FAQS_LOCAL = (cityName) => [
  {
    q: `Is BestRx available to residents of ${cityName}, TX?`,
    a: `Yes. BestRx is a Texas-licensed telehealth platform serving every ZIP code in Rockwall County, including ${cityName}. Your provider review is conducted online by a Texas-licensed clinician, and your medication ships from a licensed compounding pharmacy directly to your ${cityName} address.`,
  },
  {
    q: `What weight-loss medications can ${cityName} residents access?`,
    a: `BestRx providers can prescribe compounded Tirzepatide, compounded Semaglutide, oral GLP-1 formulations, and supportive injectables such as MIC+B12 and L-Carnitine — when clinically appropriate based on your intake.`,
  },
  {
    q: `Do I need insurance to start a BestRx weight-loss program in ${cityName}?`,
    a: `No. BestRx is a self-pay program. There are no copays, no preauthorizations, and no insurance hoops. New patients can start as low as $39 the first week*.`,
  },
  {
    q: `How long does it take to get my medication in ${cityName}?`,
    a: `Most ${cityName} patients complete intake, receive their provider review, and have medication shipped within 3–5 business days. Expedited fulfillment is available.`,
  },
  {
    q: `Is the consultation confidential?`,
    a: `Yes. All BestRx communications follow HIPAA-conscious standards. Medication ships in plain, unmarked packaging with no exterior indication of what's inside.`,
  },
  {
    q: `What if I have side effects?`,
    a: `Your assigned BestRx provider remains available throughout your program. Dose adjustments, side-effect management, and protocol changes are handled directly through the patient portal — no extra visit required.`,
  },
];

export const TIRZ_VS_SEMA = {
  intro:
    "Tirzepatide and Semaglutide are the two most-prescribed compounded GLP-1 medications in the United States. Both are administered as once-weekly subcutaneous injections and both produce significant weight loss in eligible patients — but they work slightly differently and one is often a better fit depending on your starting weight, response to GLP-1s, and budget.",
  table: [
    { label: "Class",           tirz: "Dual GIP + GLP-1 receptor agonist", sema: "GLP-1 receptor agonist (single)" },
    { label: "Average loss (12 mo)", tirz: "15–22% of body weight", sema: "10–15% of body weight" },
    { label: "Dosing",          tirz: "2.5 → 15 mg weekly titration", sema: "0.25 → 2.4 mg weekly titration" },
    { label: "Frequency",       tirz: "Once weekly", sema: "Once weekly" },
    { label: "Onset of appetite reduction", tirz: "Days 2–5", sema: "Days 4–10" },
    { label: "Best for",        tirz: "Higher starting BMI, stronger appetite", sema: "Moderate weight goals, prior GLP-1 tolerance" },
  ],
};

export const MEDICAL_REVIEWED = {
  name: "BestRx Medical Editorial Board",
  credentials: "Texas-licensed physicians and clinical pharmacists",
  last_reviewed: "2026-06-23",
};
